import { render } from "./CoursesContent.vue?vue&type=template&id=13c27eb6&scoped=true&ts=true"
import script from "./CoursesContent.vue?vue&type=script&lang=ts"
export * from "./CoursesContent.vue?vue&type=script&lang=ts"

import "./CoursesContent.vue?vue&type=style&index=0&id=13c27eb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c27eb6"]])

export default __exports__